enum AuthType {
    None = "none",
    Basic = "basic"
}

export default AuthType;